import { z } from "zod";

import { mediaSavedSchema } from "./media-saved";

export const cartonClosingSchema = z.object({
	media: mediaSavedSchema,
});
